var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12V5.6L14 2 8 5.6v6.5l-6 3.2v7.2L8.1 26l5.9-3.4 5.9 3.4 6.1-3.5v-7.2L20 12zm-1.1.1l-4.3 2.4v-5L18.9 7v5.1zM14 3.4L18.2 6 14 8.5 9.8 5.9 14 3.4zM3.8 15.6l4.8-2.5 4.2 2.4-4.7 2.7-4.3-2.6zm4.9 3.6l4.7-2.7v5.1l-4.7 2.8v-5.2zm6.5-3.7l4.2-2.4 4.8 2.6-4.4 2.5-4.6-2.7zm9.7 6.3l-4.4 2.5v-5.1l4.4-2.5v5.1z"
  })));
}

export default SvgIconHistory;